import React, { useState } from 'react'

import { Box, Grid, Typography, useMediaQuery } from '@mui/material'
import Icon from '~/components/Icon'
import { useTranslation } from 'react-i18next'
import logoIcon from '~/assets/images/MESX.svg'

import EcoSystem from '~/assets/images/home/eco-system-2.png'
import { useClasses } from '~/themes'

import style from './style'
import { redirectRouter } from '~/utils'

const ContactUsPage = () => {
  const { t } = useTranslation(['mkt'])
  const classes = useClasses(style)

  const largeScreenWidth = useMediaQuery('(min-width:720px)')

  return (
    <Box className={classes.root}>
      <Box
        className={classes.floatMenu}
        sx={
          largeScreenWidth
            ? {
                display: 'flex',
                // justifyContent: 'right',
                position: 'absolute',
                bottom: '0.5rem',
                top: '0.5rem',
              }
            : { display: 'flex', justifyContent: 'right' }
        }
      >
        <a
          onClick={() => {
            redirectRouter('/')
          }}
        >
          <Box
            sx={{
              minWidth: 80,
              height: 40,
              pl: 1.5,
              pr: 1,
              textTransform: 'uppercase',
              justifyContent: 'flex-start',
            }}
          >
            <img src={logoIcon} alt="" />
          </Box>
        </a>
      </Box>
      <Grid
        container
        className={classes.gridContainer}
        justifyContent="center"
        alignItems="center"
      >
        <Grid container justifyContent="center" lg={10} md={10} xs={12}>
          <Grid item lg={6} md={8} xs={12}>
            <Box className={classes.intro}>
              <h2>{t('contactUs.title')}</h2>
              <Typography fontSize={12}>
                {t('contactUs.description')}
              </Typography>
              <Box sx={{ marginTop: 2, display: 'flex', alignItems: 'center' }}>
                <Icon
                  color="#0050AE"
                  name="phone"
                  size={30}
                  sx={{ marginRight: 1 }}
                />
                {'  '}
                <Typography
                  fontSize={30}
                  variant="subtitle"
                  fontWeight={600}
                  color={'#0050AE'}
                >
                  {t(`contactUs.phone`)}
                </Typography>
              </Box>{' '}
              <Box sx={{ marginTop: 1, display: 'flex', alignItems: 'center' }}>
                <Icon
                  color="#0050AE"
                  name="amail"
                  size={15}
                  sx={{ marginRight: 1 }}
                />
                {'  '}
                <Typography fontSize={14} variant="subtitle" color={'#0050AE'}>
                  {t(`contactUs.mail`)}
                </Typography>
              </Box>{' '}
              <Box sx={{ marginTop: 1, display: 'flex', alignItems: 'center' }}>
                <Icon
                  color="#0050AE"
                  name="locatorPick"
                  size={14}
                  sx={{ marginRight: 1 }}
                />
                {'  '}
                <Typography fontSize={12} variant="subtitle">
                  {t(`contactUs.address`)}:
                </Typography>
              </Box>
              <ul style={{ marginTop: 1 }}>
                <li>
                  <Typography fontSize={12} variant="subtitle">
                    Trụ sở chính: VTI Building, khu đô thị Mễ Trì Hạ, Nam Từ
                    Liêm, Hà Nội
                  </Typography>
                </li>
                <li>
                  <Typography fontSize={12} variant="subtitle">
                    Chi nhánh TP.HCM: Tầng 7, VNO Building – 124 Điện Biên Phủ,
                    Phường Đa Kao, Quận 1, TP Hồ Chí Minh
                  </Typography>
                </li>
                <li>
                  <Typography fontSize={12} variant="subtitle">
                    Chi nhánh Nhật Bản: Tầng 4, Tòa nhà T&T, 8-21, Tomihisacho,
                    Shinjuku-ku, Tokyo, Nhật Bản
                  </Typography>
                </li>
              </ul>
            </Box>
          </Grid>
          <Grid item lg={6} md={8} xs={12}>
            <Box className={classes.ecoSystem}>
              <img src={EcoSystem} alt=""></img>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ContactUsPage
